<template>
    <div class="knd-login">
        <div class="knd-wrapper__sm knd-px-5">
            <span>Ik ben </span>
            <input 
                class="knd-px-1 knd-py-1 knd-login__input"
                id="user"
                autocomplete="off" 
                v-model="name" 
                :placeholder="$store.state.user.name" 
                />
            <span class="knd-pl-1">ik werk in </span>
            <select 
                v-model="work" 
                id="job-select" 
                class="knd-px-1 knd-py-1 knd-login__select"
            >
                <option 
                    v-for="(item, index) in workOptions"
                    :value="item.lidwoord + ' '+ item.label"
                    :key="'work-' + index"
                >
                {{item.lidwoord}} {{item.label}}
                </option>
            </select>

            <span class="knd-pl-1">in mijn vrije tijd doe ik aan</span>
            <select 
                v-model="hobby" 
                id="hobby-select" 
                class="knd-px-1 knd-py-1 knd-login__select"
            >
                <option 
                    v-for="(item, index) in hobbyOptions"
                    :value="item.label"
                    :key="'hobby-' + index"
                >
                    {{item.label}}
                </option>
            </select>
        </div>

        <div class="knd-login__btn ">
            <button 
                class="knd-btn knd-my-5 knd-px-3 knd-py-2 knd-rounded-md" 
                @click="login">
                Start je gesprek met {{$store.state.match.name}}

                
            </button>
                <svg width="27" height="29" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="knd-animate-bounce" d="M11.7692 24.0488L11.7692 -1.51314e-06L15.2308 -1.16925e-06L15.2308 24.0488C16.0615 21.9268 17.4462 20.0642 19.3846 18.461C21.3231 16.8577 23.8615 15.8911 27 15.561L27 19.0976C24.0923 19.4276 21.6 20.5594 19.5231 22.4927C17.4462 24.4732 16.0154 26.6423 15.2308 29L11.7692 29C10.9846 26.6423 9.55384 24.4732 7.47692 22.4927C5.4 20.5593 2.90769 19.4276 -1.8973e-06 19.0976L-1.54595e-06 15.561C3.13846 15.8911 5.67692 16.8577 7.61538 18.461C9.55384 20.0642 10.9385 21.9268 11.7692 24.0488Z" fill="black"/>
                </svg>
        </div>

    </div>
</template>

<script>
import {sleep} from '../../utils/main';

let workArr = [
    {label: 'financiele sector', lidwoord: 'de'},
    {label: 'onderwijs', lidwoord: 'het'},
    {label: 'zorg', lidwoord: 'de'},
    {label: 'ICT', lidwoord: 'de'},
    {label: 'bouw', lidwoord: 'de'},
    {label: 'media', lidwoord: 'de'},
    {label: 'agrarische sector', lidwoord: 'de'},
    {label: 'transport', lidwoord: 'het'},
    {label: 'ambtenarij', lidwoord: 'de'},
]

let hobbyArr = [
    {label: 'zeilen'},
    {label: 'dansen'},
    {label: 'schaken'},
    {label: 'zwemmen'},
    {label: 'schaatsen'},
    {label: 'hardlopen'},
    {label: 'wielrennen'},
    {label: 'wandelen'},
    {label: 'klussen'},
    {label: 'shoppen'},    
]

    export default {
        data: function() {
            return {
                workOptions: workArr,
                hobbyOptions: hobbyArr,
                name: this.$store.state.user.name,
                work: this.$store.state.user.work,
                hobby: this.$store.state.user.hobby
            }
        },
        methods: {
            async login() {
                let obj = {
                    name: this.name,
                    hobby: this.hobby,
                    work: this.work
                };

                this.$store.dispatch('login', obj);

                await sleep(600);

                let el = document.querySelector('.chat');
                const viewportmeta = document.querySelector('meta[name=viewport]');
                viewportmeta.setAttribute('content', "initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0");

                el.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
        },
    }
</script>

<style lang="scss" scoped>

.knd-login {
    position: relative;
    .knd-login__input {
        background: theme('colors.red.light');
        border-bottom: none; 
        width: 80px;   
        border-radius: 4px;
        margin-right: 2px;   
    }

    .knd-login__select {
        background: theme('colors.red.light');
        border-bottom: none;
        border-radius: 4px;

    }

    .knd-login__btn {
        text-align: center;
        margin-top: 12px;
        border-radius: 4rem;
        margin-bottom: 5px;

        svg {
            display: block;
            margin: 0 auto;
            height: 15px; 
        }
    }
}
    
</style>